import React, { useState } from 'react';
import { red } from '@material-ui/core/colors';
import { Layout } from './constant';
// A custom theme for this app
import GSBFont from '../../assets/fonts/GSB.ttf';
import DBHeaventFornt from '../../assets/fonts/DBHeavent.ttf';
import DBHeaventBdFont from '../../assets/fonts/DBHeaventBd.ttf';

const GSB = {
   fontFamily: 'GSB',
   fontStyle: 'normal',
   fontDisplay: 'swap',
   fontWeight: 400,
   src: `
    url(${GSBFont}) format('truetype')
  `,
};
const DBHeavent = {
   fontFamily: 'DBHeavent',
   fontStyle: 'normal',
   fontDisplay: 'swap',
   fontWeight: 400,
   src: `
    url(${DBHeaventFornt}) format('truetype')
  `,
};
const DBHeaventBd = {
   fontFamily: 'DBHeaventBd',
   src: `
    url(${DBHeaventBdFont}) format('truetype')
  `,
};
export const myTheme = {
   palette: {
      primary: {
         main: Layout.primary,
      },
      secondary: {
         main: Layout.secondary,
      },
      error: {
         main: red.A400,
      },
      type: 'light',
   },
   themeName: 'awesome theme',
   typography: {
      fontFamily: ['DBHeavent', 'GSB', 'DBHeaventBd'].join(','),
      h1: {
         fontFamily: 'GSB',
      },
      h2: {
         fontFamily: 'GSB',
      },
      h3: {
         fontFamily: 'GSB',
      },
      h4: {
         fontFamily: 'GSB',
      },
      h5: {
         fontFamily: 'GSB',
      },
      h6: {
         fontFamily: 'GSB',
      },
      button: {
         fontFamily: 'GSB',
      },
   },
   overrides: {
      MuiCssBaseline: {
         '@global': {
            '@font-face': [GSB, DBHeavent, DBHeaventBd],
         },
      },
      MuiTypography: {
         body1: {
            fontFamily: 'DBHeavent', // old GSB
            fontSize: '1.2rem',
         },
      },
      MuiButton: {
         label: {
            fontFamily: 'DBHeavent',
            fontSize: '1.2rem',
         },
      },
      MuiTableCell: {
         root: {
            fontSize: '1.2rem',
         },
      },
      MuiTableBody: {
         root: {
            fontSize: '1.2rem',
         },
      },
      MuiInputBase: {
         root: {
            fontFamily: 'GSB',
         },
      },
      MuiFormLabel: {
         root: {
            fontFamily: 'GSB',
         },
      },
      MuiStepIcon: {
         text: {
            fontSize: '1rem',
            fontFamily: 'GSB',
         },
      },
      MuiStepLabel: {
         label: {
            fontSize: '1rem',
         },
      },
      MuiToggleButton: {
         root: {
            width: '100%',
         },
         label: {
            fontFamily: 'DBHeavent',
            fontSize: '1.2rem',
            lineHeight: 1,
         },
      },
      MuiToggleButtonGroup: {
         root: {
            display: 'flex',
         },
      },
      MuiButtonBase: {
         root: {
            fontFamily: 'DBHeavent',
            fontSize: '1.2rem',
         },
      },
      MuiTab: {
         root: {
            fontFamily: 'DBHeavent',
            fontSize: '1.2rem',
         },
      },
      MuiSnackbarContent: {
         root: {
            fontFamily: 'DBHeavent',
            fontSize: '1.4rem',
         },
      },
   },
};

export const useDarkMode = () => {
   const [theme, setTheme] = useState(myTheme);
   const {
      palette: { type },
   } = theme;
   const toggleDarkMode = () => {
      const updatedTheme = {
         ...theme,
         palette: {
            ...theme.palette,
            type: type === 'light' ? 'dark' : 'light',
         },
      };
      setTheme(updatedTheme);
   };
   return [theme, toggleDarkMode];
};
